import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Link = styled.a`
    display: contents;
    cursor: pointer;

    ${FONTS.MediumXS};

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${FONTS.MediumS};
    }
`;
